module.exports = __webpack_public_path__ + "img/wechatScanResult.4319580d.png";